import styles from './MessageBox.module.css';

import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

export const MessageBox = () => {
    return (
        <div className={ styles.container }>
            <div className={ styles.titleBar }>
                <Typography variant="h6">Todo List</Typography>
            </div>

            <div className={ styles.content }>
                <List sx={ { bgcolor: 'background.paper' } }>
                    <ListItem>
                        <ListItemIcon sx={ { minWidth: 'auto', mr: 1 } }>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        
                        <ListItemText primary="Add items that you want sold at the ski swap." />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon sx={ { minWidth: 'auto', mr: 1 } }>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        
                        <ListItemText
                            primary={
                                <div style={ { display: 'flex', alignItems: 'center', gap: '8px' } }>
                                    Pay listing fee to have the items included in the swap.
                                    <Tooltip
                                        title="Cash payments can be made at the registration table during drop-off hours. Bring exact change when possible."
                                        slotProps={ {
                                            tooltip: {
                                                sx: {
                                                    fontSize: '14px',
                                                    fontWeight: 400
                                                }
                                            }
                                        } }
                                    >
                                        <IconButton size="small" sx={ { p: 0.5 } }>
                                            <InfoIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }
                            secondary="$2.00 per item • Cash or card accepted"
                            slotProps={ {
                                secondary: {
                                    sx: { color: 'primary.main' }
                                }
                            } }
                        />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon sx={ { minWidth: 'auto', mr: 1 } }>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        
                        <ListItemText
                            primary="Drop off items at Powder Ridge"
                            secondary="Friday, Nov 7: 5:00pm - 8:00pm or Saturday, Nov 8: 8:00am - 10:00am"
                            slotProps={ {
                                secondary: {
                                    sx: { color: 'success.main' }
                                }
                            } }
                        />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon sx={ { minWidth: 'auto', mr: 1 } }>
                            <KeyboardArrowRight />
                        </ListItemIcon>
                        
                        <ListItemText
                            primary="Shop the swap!"
                            secondary="Saturday, Nov 8: 10:30am - 4:00pm"
                            slotProps={ {
                                secondary: {
                                    sx: { color: 'info.main' }
                                }
                            } }
                        />
                    </ListItem>

                    <ListItem>
                        <ListItemIcon sx={ { minWidth: 'auto', mr: 1 } }>
                            <KeyboardArrowRight />
                        </ListItemIcon>

                        <ListItemText
                            primary="Pick up remaining items and collect payment."
                            secondary="Sunday, Nov 9: 12:00pm - 3:00pm"
                            slotProps={ {
                                secondary: {
                                    sx: { color: 'error.main' }
                                }
                            } }
                        />
                    </ListItem>
                </List>
            </div>
        </div>
    );
};